var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99938 0C7.75998 0 10.0012 2.24457 10 5.00792C9.99877 7.77559 7.71994 10.0485 4.90574 9.99921C2.23632 9.95239 0.00123264 7.76943 5.06531e-07 4.99745C-0.00123163 2.24211 2.24556 0 4.99938 0ZM5.09456 0.72118C5.09437 0.720984 5.0941 0.72087 5.09382 0.720862C2.82441 0.655179 0.807659 2.46222 0.720183 4.84773C0.635782 7.15823 2.42669 9.15265 4.77883 9.27895C7.1396 9.40526 9.16584 7.57288 9.28043 5.20385C9.39748 2.77891 7.46266 0.762407 5.09532 0.721499C5.09503 0.721494 5.09476 0.72138 5.09456 0.72118V0.72118Z",
    fill: "#C2131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09668 3V5.5L6.59668 7",
    stroke: "#C2131A",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsicon);
export default __webpack_public_path__ + "static/media/questionsicon.5237b9c4eeff20a284aa556a43434819.svg";
export { ForwardRef as ReactComponent };